import { inject } from 'aurelia-framework';
// import { bindable } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { EnvironmentService } from '../../services/environmentService';
import { AuthService } from '../../services/authService';
import { TestimonialCaptureAPI } from '../../services/testimonialCaptureAPI';
import { VideoCaptureLogAPI } from '../../services/videoCaptureLogAPI';
import { UserMessageService } from '../../services/userMessageService';
import { VideoMessageAPI } from '../../services/videoMessageAPI';


@inject(EnvironmentService, AuthService, Router, VideoCaptureLogAPI, UserMessageService, VideoMessageAPI)
export class VideoCapture {

    // @bindable showComposeEmailButton;

    constructor(envService, authService, router, logApi ,userMessageService, videoMessageAPI) {

        this.envService = envService;
        this.authService = authService;
        this.router = router;
        this.userMessageService = userMessageService;
        this.videoMessageAPI = videoMessageAPI;
        this.logApi = logApi;
        this.androidDevice = false;

        this.useWebRTC = true;
        this.useFileUpload = false;

        this.ready = false;
        this.recording = false;
        this.recorded = false;
        this.playing = false;
        this.saving = false;
        this.pending = false;

        this.capture_key = null;

        this.showRecorder = false;

        this.recorder = null;

        this.validateName = false;
        this.validateEmail = false;
        this.savingUserInfo = false;

        this.testimonialForm = 0;
        this.maxRecordTime = 55;

        this.mobile = this.envService.isMobile();

        this.uploadOnly = false;

        this.showComplete = false;

        this.capture_bottom_img = "images/capture_bottom.png";

        if (window.whitelabel) {
            this.capture_bottom_img = "api/whitelabel/getFile?file=capture_bottom";
        }

        this.home_url = window.location.origin;

        this.composeEmailShow = false;
        this.composeEmailEnable = true;

        this.videoFile = null;
        this.blobURL = null;

        this.uploadFlag = null;
        this.fileUploadScreen = false;
        console.log("window.location.href", window.location.href);
        // this.uploadFlag = window.location.href.split("=")[2]
        this.uploadFlag = window.location.href.includes("videoUpload");
        console.log("window.location.href flag", this.uploadFlag);

        this.fileUploadScreen = this.uploadFlag;

        this.showMessage = false;
        this.progressFileUpload = 0;
        this.showUploadVideoPreview = false;
        this.showSubmitButton = false;
        this.disablePlaybuttonSafari = false;

        this.browserName = this.envService.browserDetails();
        this.browserAppVersion = navigator.appVersion;

        if (this.browserName.name == "Safari" && !this.envService.isMobile()) {
            this.disablePlaybuttonSafari = true;
        }
        this.showRecordButtons = !this.envService.isIOS()

        //     this.versionBrowser = this.browserAppVersion.split("Version/")[1];

        //     this.version = this.versionBrowser.split(/[\s.]+/);
        //     console.log("browser detail", navigator,"..", this.version[0]);

        //     if(this.browserName.name=="Safari" && this.version[0] >= 14) {
        //         if(this.captureType == 3)
        //                         this.router.navigate("#/capture/unsupported?url=video/email/" + this.video_id);
        //                     else
        //                         this.router.navigate("#/capture/unsupported?url=" + (this.captureType == 1 ? "link/" : (this.captureType == 2 ? "brand/" : "")) + this.capture_key);
        //         // this.router.navigate("#/capture/unsupported");
        //     }
        // }

        this.brandedVideo = false;
        if (window.location.href.indexOf("capture/video/brand") > -1 || window.location.href.indexOf("capture/video/expertTipVideo") > -1) {
            console.log('>>>>> Branded Video <<<<<<');
            this.brandedVideo = true;
        }

        this.show_recorder = false;
        this.selected_screen = "ONLY_CAM";
        this.showOnlyCam = true;

        this.count = 0;
        this.cameraId = 0;
        this.products = [];
        this.deviceIds = [];
        this.products = [];
        this.deviceIdsAudio = [];
        this.productsAudio = [];

    }


    toggleShowModal() {

     
    //   let url = window.location.href;

      if(!this.envService.canUseWebRTC()){
        let newUrl = url.split("#/capture/")[1];
        this.determineCaptureMethod(newUrl, true);
      }

        this.show_recorder = true;
        this.showOnlyCam = false;

        navigator.permissions
            .query({ name: "camera" })
            .then(
                function (result) {
                    if (result.state === "prompt") {
                        navigator.mediaDevices
                            .getUserMedia({ audio: true, video: true })
                            .then(
                                function () {
                                    this.gotDevices();
                                }.bind(this)
                            );
                    } else if (result.state === "granted") {
                        this.gotDevices();
                    } else if (result.state === "denied") {
                        this.userMessageService.setUserError(
                            "user",
                            "Please Allow Camera and Microphone permission"
                        );
                    }
                }.bind(this)
            )
            .catch(
                // for firefox
                function () {
                    console.log("before error");
                    navigator.mediaDevices
                        .getUserMedia({ audio: true, video: true })
                        .then(
                            function () {
                                this.gotDevices();
                            }.bind(this)
                        )
                        .catch(
                            function () {
                                this.userMessageService.setUserError(
                                    "user",
                                    "Please Allow Camera and Microphone permission"
                                );
                            }.bind(this)
                        );
                }.bind(this)
            );

        // }
    }

    updateScreen(screen) {
        this.selected_screen = screen;
    }

    cameraChanged(cameraId) {
        console.log("Camera id switched" + cameraId);
        this.camera = cameraId;
    }

    audioChanged(audioId) {
        console.log("audio id switched" + audioId);
        this.audio = audioId;
    }
    gotDevices() {
        navigator.permissions
            .query({ name: "camera" })
            .then(
                function (result) {
                    console.log(result.state);
                    this.products = [];
                    this.deviceIdsAudio = [];
                    this.productsAudio = [];

                    if (result.state === "granted") {
                        navigator.mediaDevices.enumerateDevices().then(
                            function (devices) {
                                let products = [];
                                let deviceIds = [];
                                let deviceIdsAudio = [];
                                let productsAudio = [];

                                devices.forEach(function (device) {
                                    console.log("=================================");
                                    console.log("devices=>", device);
                                    console.log("camera kind ", device.kind);
                                    console.log("camera label ", device.label);
                                    console.log("camera id ", device.deviceId);
                                    console.log("=================================");
                                    if (device.kind == "videoinput") {
                                        //let temp = {};
                                        let temp = { id: device.deviceId, name: device.label };
                                        products.push(temp);
                                        deviceIds.push(device.deviceId);
                                    } else if (device.kind == "audioinput") {
                                        let temp = { id: device.deviceId, name: device.label };
                                        productsAudio.push(temp);
                                        deviceIdsAudio.push(device.deviceId);
                                    }

                                    // data.push(device.kind + ":*** " + device.label + " id** = " + device.deviceId);
                                });
                                this.products = products;
                                this.deviceIds = deviceIds;
                                this.productsAudio = productsAudio;
                                this.deviceIdsAudio = deviceIdsAudio;

                                console.log(
                                    " Devices Ids gotDevices",
                                    JSON.stringify(deviceIds)
                                );
                                this.selectedProductId = this.deviceIds[0];
                                this.selectedProductIdAudio = this.deviceIdsAudio[0];
                                this.camera = this.deviceIds[0];
                                this.audio = this.deviceIdsAudio[0];

                                //this.openMediaStream();
                                // this.reportLogMessage({ msg: "UserDevices: " + JSON.stringify(data) });
                            }.bind(this)
                        );

                        //permission has already been granted, no prompt is shown
                    } else if (result.state === "prompt") {
                        // navigator.mediaDevices
                        //   .getUserMedia({ audio: true, video: true })
                        //   .then(
                        //     function () {


                        navigator.mediaDevices.enumerateDevices().then(
                            function (devices) {
                                let products = [];
                                let deviceIds = [];
                                let deviceIdsAudio = [];
                                let productsAudio = [];

                                devices.forEach(function (device) {
                                    console.log("=================================");
                                    console.log("devices=>", device);
                                    console.log("camera kind ", device.kind);
                                    console.log("camera label ", device.label);
                                    console.log("camera id ", device.deviceId);
                                    console.log("=================================");
                                    if (device.kind == "videoinput") {
                                        //let temp = {};
                                        let temp = {
                                            id: device.deviceId,
                                            name: device.label,
                                        };
                                        products.push(temp);
                                        deviceIds.push(device.deviceId);
                                    } else if (device.kind == "audioinput") {
                                        let temp = {
                                            id: device.deviceId,
                                            name: device.label,
                                        };
                                        productsAudio.push(temp);
                                        deviceIdsAudio.push(device.deviceId);
                                    }

                                    // data.push(device.kind + ":*** " + device.label + " id** = " + device.deviceId);
                                });
                                this.products = products;
                                this.deviceIds = deviceIds;
                                this.productsAudio = productsAudio;
                                this.deviceIdsAudio = deviceIdsAudio;

                                console.log(
                                    " Devices Ids gotDevices",
                                    JSON.stringify(deviceIds)
                                );
                                this.selectedProductId = this.deviceIds[0];
                                this.selectedProductIdAudio = this.deviceIdsAudio[0];
                                this.camera = this.deviceIds[0];
                                this.audio = this.deviceIdsAudio[0];

                                //this.openMediaStream();
                                // this.reportLogMessage({ msg: "UserDevices: " + JSON.stringify(data) });
                            }.bind(this)
                        );
                        // }.bind(this)
                        // ).catch(function(){

                        //       this.userMessageService.setUserError(
                        //         "user",
                        //         "Please Allow Camera and Microphone permission"
                        //       );
                        //     }.bind(this)
                        // );

                        //  there's no peristent permission registered, will be showing the prompt
                    } else if (result.state === "denied") {
                        //permission has been denied

                        // this.userMessageService.setUserError(
                        //   "user",
                        //   "Please Allow Camera and Microphone permission"
                        // );
                    }
                }.bind(this)
            )
            .catch(
                function (err) {
                    // navigator.mediaDevices
                    //   .getUserMedia({ audio: true, video: true })
                    //   .then(
                    //     function () {


                    navigator.mediaDevices.enumerateDevices().then(
                        function (devices) {
                            let products = [];
                            let deviceIds = [];
                            let deviceIdsAudio = [];
                            let productsAudio = [];

                            devices.forEach(function (device) {
                                console.log("=================================");
                                console.log("devices=>", device);
                                console.log("camera kind ", device.kind);
                                console.log("camera label ", device.label);
                                console.log("camera id ", device.deviceId);
                                console.log("=================================");
                                if (device.kind == "videoinput") {
                                    //let temp = {};
                                    let temp = { id: device.deviceId, name: device.label };
                                    products.push(temp);
                                    deviceIds.push(device.deviceId);
                                } else if (device.kind == "audioinput") {
                                    let temp = { id: device.deviceId, name: device.label };
                                    productsAudio.push(temp);
                                    deviceIdsAudio.push(device.deviceId);
                                }

                                // data.push(device.kind + ":*** " + device.label + " id** = " + device.deviceId);
                            });
                            this.products = products;
                            this.deviceIds = deviceIds;
                            this.productsAudio = productsAudio;
                            this.deviceIdsAudio = deviceIdsAudio;

                            console.log(
                                " Devices Ids gotDevices",
                                JSON.stringify(deviceIds)
                            );
                            this.selectedProductId = this.deviceIds[0];
                            this.selectedProductIdAudio = this.deviceIdsAudio[0];
                            this.camera = this.deviceIds[0];
                            this.audio = this.deviceIdsAudio[0];

                            //this.openMediaStream();
                            // this.reportLogMessage({ msg: "UserDevices: " + JSON.stringify(data) });
                        }.bind(this)
                    );
                }.bind(this))
        // .catch(
        //   function () {
        //     this.userMessageService.setUserError(
        //       "user",
        //       "Please Allow Camera and Microphone permission"
        //     );
        //   }.bind(this)
        // );
        // }.bind(this)
        // );
    }

    startVideoCapture() {

        // if (this.validate()) {
        if (this.selected_screen === 'ONLY_CAM') {

           this.show_recorder=false;
           this.showOnlyCam = true;

        } else {
            this.showOnlyCam = false;
            this.show_recorder = false;
            this.captureScreen(false)
        }

        localStorage.setItem('magni_v_device_id', this.camera)
        localStorage.setItem('magni_a_device_id', this.audio)

    }
    // }

    captureScreen(flag = false) {


      let magnfi_recorder =  JSON.stringify({
            capture_key: sessionStorage["magnfi_captureKey"],
            video_id:this.video_id,
            upload: false,
            video_email: false,
            portrait: false,
            is_branded_video: false,
            video_message: true,
        })

        if (!flag) {
            localStorage.setItem("magni_screen", this.selected_screen);
            localStorage.setItem(
                "magni_recorder",
             magnfi_recorder
            );

            let w = 840,
                h = 680;
            var left = screen.width / 2 - w / 2;
            var top = screen.height / 2 - h / 2;
            // this.router.navigate("#/capture/video/email/" + this.id + "?captureType=3");
            let opener = window.open(
                "/screen-recorder/build/index.html?"+window.location.href.split("?")[1],
                "_blank",
                `toolbar=yes,scrollbars=tes,resizable=yes,top=${top},left=${left},width=${w},height=${h}`
            );
            opener.addEventListener('beforeunload', function(event) {
              let url = window.location.href;
              if (url.includes('_host_Info')) {
                var origin= window.location.origin
                $.getScript("https://appsforoffice.microsoft.com/lib/1.1/hosted/office.js").then(function () {
                  Office.onReady(function () {
                      Office.context.ui.messageParent('video recorded or uploaded successfully', { targetOrigin: origin });
                  });
                });
              }
            });

            // this.router.navigate("#/capture/video/message/" + this.id + "?captureType=5");
        } else {
            this.router.navigate(
                "#/capture/video/message/" +
                this.id +
                "?captureType=5" +
                "?videoUpload=1"
            );
        }

        //     ,
        //     null
        //     // this.saveLoadError.bind(this)
        //   );
        // }
    }

    activate(model, route) {

        let params = (new URL(document.location)).searchParams;
        let url = window.location.href;
        if (params && params.get('_host_Info')) {
            // this.openRecordScreen();
            let host = params.get('_host_Info');
            let newhost = '?_host_Info=' + host;
            let completeUrl = window.location.href;
            let newLoc = completeUrl.replace(newhost, '');
            newLoc += '&_host_Info=' + host;
            console.log("new url ==========>", newLoc);
            window.location.replace(newLoc);


        }else if(url.includes('_host_Info') && !url.includes("videoUpload") && this.browserName.name == "Safari"){
          // let url = window.location.href;
          console.log("current url in activate =================>", url);
          // if (url.includes('_host_Info') && !url.includes("videoUpload")) {
            console.log("host info and not upload video");
            // if(this.browserName.name == "Safari"){
              let newUrl = url.split("#/capture/")[1];
              console.log("copy url activate ==============>", newUrl);
              this.router.navigate("#/capture/unsupported?url=" + newUrl);
              // this.determineCaptureMethod(newUrl, true);
          //   }
          // }
        }else{
            if(model._host_Info && !model.videoUpload){
                this.toggleShowModal();
            }

            // console.log('Rowdddd',model,'ss', route)
            if (model.link)
                this.capture_key = model.link;

            if (model.link_id) {
                sessionStorage['magnfi_captureKey'] = model.link_id;
            }

            this.testimonialForm = route.settings.testimonialForm;

            if (model.method)
                this.method = model.method;

            if (model.return && model.return == 1)
                this.return = true;

            if (model.uploadonly && model.uploadonly == 1)
                this.uploadOnly = true

            if (model.user_id)
                this.user_id = model.user_id



            if (route.settings && route.settings.captureType)
                this.captureType = route.settings.captureType;
            else
                this.captureType = 0;


            switch (this.captureType) {
                case 0:
                    this.maxRecordTime = 55;
                    this.capture_key = model.key;
                    break;
                case 1:
                    this.maxRecordTime = 55;
                    this.video_id = model.id;
                    this.capture_key = sessionStorage['magnfi_captureKey'];
                    if (!this.capture_key)
                        this.capture_key = model.key
                    break;
                case 2:
                    this.maxRecordTime = 95;
                    this.video_id = model.id;
                    if (model.link)
                        this.capture_key = model.link;
                    else
                        this.capture_key = sessionStorage['magnfi_captureKey'];
                    break;
                case 3:
                    this.maxRecordTime = 185;
                    this.video_id = model.id;
                    this.capture_key = sessionStorage['magnfi_captureKey'];
                    break;
                case 5:
                    this.maxRecordTime = 185;
                    this.video_id = model.id;
                    this.capture_key = sessionStorage['magnfi_captureKey'];
                    break;
                case 4:
                    this.maxRecordTime = 35;
                    this.capture_key = model.key;
                    break;
            }


            if (!this.capture_key) {
                if (this.captureType == 3)
                    this.cancel();
                else if (this.captureType == 5)
                    this.cancel();
                else
                    this.router.navigate("/");
            }

            this.showComplete = false;

            this.api = new TestimonialCaptureAPI(this.captureType);
        }
        // if(model._host_Info && !model.videoUpload){
        //     this.toggleShowModal();
        // }

        // console.log('Rowdddd',model,'ss', route)
        if (model.link)
            this.capture_key = model.link;

        if (model.link_id) {
            sessionStorage['magnfi_captureKey'] = model.link_id;
        }

        this.testimonialForm = route.settings.testimonialForm;

        if (model.method)
            this.method = model.method;

        if (model.return && model.return == 1)
            this.return = true;

        if (model.uploadonly && model.uploadonly == 1)
            this.uploadOnly = true


        if (route.settings && route.settings.captureType)
            this.captureType = route.settings.captureType;
        else
            this.captureType = 0;


        switch (this.captureType) {
            case 0:
                this.maxRecordTime = 55;
                this.capture_key = model.key;
                break;
            case 1:
                this.maxRecordTime = 55;
                this.video_id = model.id;
                this.capture_key = sessionStorage['magnfi_captureKey'];
                if (!this.capture_key)
                    this.capture_key = model.key
                break;
            case 2:
                this.maxRecordTime = 95;
                this.video_id = model.id;
                if (model.link)
                    this.capture_key = model.link;
                else
                    this.capture_key = sessionStorage['magnfi_captureKey'];
                break;
            case 3:
                this.maxRecordTime = 185;
                this.video_id = model.id;
                this.capture_key = sessionStorage['magnfi_captureKey'];
                break;
            case 5:
                this.maxRecordTime = 185;
                this.video_id = model.id;
                this.capture_key = sessionStorage['magnfi_captureKey'];
                break;
            case 4:
                this.maxRecordTime = 35;
                this.capture_key = model.key;
                break;
        }


        if (!this.capture_key) {
            if (this.captureType == 3)
                this.cancel();
            else if (this.captureType == 5)
                this.cancel();
            else
                this.router.navigate("/");
        }

        this.showComplete = false;

        this.api = new TestimonialCaptureAPI(this.captureType);
    

    }

    attached() {

        this.uploadFlag = window.location.href.includes("videoUpload");
        this.fileUploadScreen = this.uploadFlag;
        if (this.capture_key) {
            this.api.getByCaptureKey(this.capture_key, this.saveLoadSuccess.bind(this), this.saveLoadError.bind(this), this.video_id);
        }
        if (sessionStorage["magnfi_capture_inst_closed"])
            this.closeInstructions();

        this._debug = console.debug;
        this._log = console.log;
        this._info = console.info;
        this._warn = console.warn;
        this._error = console.error;
        this._exception = console.exception;

        if (typeof console.debug === "function") {

            console.debug = function () {
                var args = Array.prototype.slice.call(arguments);

                var msg = this.logArgsToString(args);

                this.reportLogMessage("DEBUG: " + msg);
                this._debug.apply(console, args);


            }.bind(this);
        }

        if (typeof console.log === "function") {

            console.log = function () {
                var args = Array.prototype.slice.call(arguments);

                var msg = this.logArgsToString(args);

                this.reportLogMessage(msg);
                this._log.apply(console, args);


            }.bind(this);
        }

        if (typeof console.info === "function") {

            console.info = function () {
                var args = Array.prototype.slice.call(arguments);

                var msg = this.logArgsToString(args);

                this.reportLogMessage("INFO: " + msg);
                this._info.apply(console, args);


            }.bind(this);
        }

        if (typeof console.warn === "function") {

            console.warn = function () {
                var args = Array.prototype.slice.call(arguments);

                var msg = this.logArgsToString(args);

                this.reportLogMessage("WARN: " + msg);
                this._warn.apply(console, args);


            }.bind(this);
        }

        if (typeof console.error === "function") {

            console.error = function () {
                var args = Array.prototype.slice.call(arguments);

                var msg = this.logArgsToString(args);

                this.reportLogMessage("ERROR: " + msg);
                this._error.apply(console, args);


            }.bind(this);
        }

        if (typeof console.exception === "function") {

            console.exception = function () {
                var args = Array.prototype.slice.call(arguments);

                var msg = this.logArgsToString(args);

                this.reportLogMessage("EXCEPTION: " + msg);
                this._exception.apply(console, args);


            }.bind(this);
        }

        window.onerror = function (message, url, linenumber) {
            console.log("JavaScript error: " + message + " on line " +
                linenumber + " for " + url);
        }


    }

    openRecordScreen() {


        let magnfi_recorder= JSON.stringify({
            capture_key: this.capture_key,
            video_id: this.video_id,
            upload: this.uploadFlag,
            video_email: (this.captureType == 3 || this.uploadFlag),
            portrait: this.iOS(),
            is_branded_video: this.brandedVideo,
            video_message: (this.captureType == 5 || this.uploadFlag),
        })

        localStorage.setItem('magni_recorder',magnfi_recorder)


        window.open("/screen-recorder/build/index.html", "_blank", `toolbar=yes,scrollbars=tes,resizable=yes,top=0,left=0,width=${screen.width},height=${screen.height}`);
    }

    iOS() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
    logArgsToString(args) {
        var msg = "";

        for (var i = 0; i < args.length; i++) {
            if (i > 0)
                msg += ", ";

            if (args[i] && typeof args[i].name !== 'undefined' && typeof args[i].message !== 'undefined') {
                msg += args[i].name + ": " + args[i].message;
            }
            else if (typeof args[i] === 'object') {
                args[i] = args[i] ? args[i].toString : '';
                if (typeof args[i].toString === "function") {
                    msg += args[i].toString();
                } else {
                    msg += JSON.stringify(args[i]);
                }
            }
            else
                msg += args[i];

        }

        return msg;
    }

    detached() {
        console.debug = this._debug;
        console.log = this._log;
        console.info = this._info;
        console.warn = this._warn;
        console.error = this._error;
        console.exception = this._exception;
        window.onerror = null;
        localStorage.setItem('uploadFileProgress', 0);

        // window.localStorage.removeItem('uploadFileProgress');
        if (this.recorder && this.recorder.kill)
            this.recorder.kill();
    }

    determineCaptureMethod(url = '', isHostInfo = false) {
      if(isHostInfo){
        console.log("copy url ==============>", url);
        this.router.navigate("#/capture/unsupported?url=" + url);
      }else{

        this.useWebRTC = true;


        if (this.browserName.name == "Safari" && !this.envService.isMobile()) {
            //Redirect the Safari Desktop user to unsupported page untill we fix the WebRTC thing
            this.versionBrowser = this.browserAppVersion.split("Version/")[1];

            this.version = this.versionBrowser.split(/[\s.]+/);
            console.log("browser detail", navigator, "..", this.version[0]);

            //if(this.browserName.name=="Safari" && this.version[0] >= 14) {
            if (this.browserName.name == "Safari") { //open for all desktop safari usres
                if (this.captureType == 3)
                    this.router.navigate("#/capture/unsupported?url=video/email/" + this.video_id);
                else if (this.captureType == 5) {
                    this.router.navigate("#/capture/unsupported?url=video/message/" + this.video_id);
                }
                else
                    this.router.navigate("#/capture/unsupported?url=" + (this.captureType == 1 ? "link/" : (this.captureType == 2 ? "brand/" : "")) + this.capture_key);
                // this.router.navigate("#/capture/unsupported");
            }
        }



        if (this.method) {
            if (this.method == "hdfvr")
                this.useWebRTC = false
            else if (this.method == "fileupload") {
                this.useWebRTC = false;
                this.useFileUpload = true;
            }
        } else {

            if (this.envService.isMobile()) {


                var supportedChrome = false;

                if (this.envService.isChrome()) {
                    supportedChrome = true;

                    if (this.chrome_min_ver) {
                        var version = this.envService.getBrowserVersion();


                        supportedChrome = parseInt(this.chrome_min_ver) <= version;
                    }
                }

                if (this.envService.isAndroid() && !supportedChrome) {
                    if (this.envService.isChrome())
                        this.router.navigate("#/capture/unsupported");
                    else {
                        if (this.captureType == 3)
                            this.router.navigate("#/capture/unsupported?url=video/email/" + this.video_id);
                        else if (this.captureType == 5)
                            this.router.navigate("#/capture/unsupported?url=video/message/" + this.video_id);
                        else
                            this.router.navigate("#/capture/unsupported?url=" + (this.captureType == 1 ? "link/" : (this.captureType == 2 ? "brand/" : "")) + this.capture_key);
                    }
                    return true;
                }

                if (!this.envService.canUseWebRTC()) {
                    //this.router.navigate("#/capture/unsupported");

                    this.useFileUpload = true;
                    this.useWebRTC = false;
                }
                if (this.envService.canUseWebRTC() && this.envService.isSafari()) {
                    //WebRTC is not working in safari do disallow to use WebRTC on mobile device using safari browser
                    this.useFileUpload = true;
                    this.useWebRTC = false;
                }

            } else {
                this.useWebRTC = this.envService.canUseWebRTC();

                // if(!this.useWebRTC && window.whitelabel) {
                //     if(this.captureType == 3)
                //         this.router.navigate("#/capture/unsupported?url=video/email/" + this.video_id);
                //     else
                //         this.router.navigate("#/capture/unsupported?url=" + (this.captureType == 1 ? "link/" : (this.captureType == 2 ? "brand/" : "")) + this.capture_key);
                // }
            }
        }
        return false;

      }
    }





    saveLoadSuccess(org_name, website, mlink_return_url, chrome_min_ver, instructions, topic) {

        this.setData(org_name, mlink_return_url, chrome_min_ver, instructions, topic);

        if (this.determineCaptureMethod())
            return;

        if (this.envService.isAndroid()) {
            this.androidDevice = true;
        }

        this.showRecorder = true;

        if (this.useWebRTC)
            this.recorder = this.webrtc;
        else {
            if (this.useFileUpload)
                this.recorder = this.fileupload;
            else
                this.recorder = this.hdfvr;
        }


        this.reportLogMessage("Initializing Recorder, using " + (this.useWebRTC ? "webrtc" : (this.useFileUpload ? "file upload" : "hdfvr")));
        if (this.fileUploadScreen == false) {
            this.recorder.display();
        }



    }

    saveLoadError(msg) {

        if (msg == "invalid key")
            this.router.navigate("/");
        else
            this.reportError(msg);

    }


    captureCompleteSuccess(done = true) {

        sessionStorage['magnfi_captureKey'] = null;
        console.log("Capture Type: " + this.captureType)
        this.reportLogMessage("Capture complete");
        if (this.captureType == 2) {
            this.showComplete = true;
            //setTimeout(() => {window.close();}, 1000);
            if (window.location.href.includes("expertTipVideo")) {
                this.router.navigate("#/capture/thankyouext=1&url=#/");
            } else {
                console.log('miss',this.authService)
                if(!this.authService.getUser()){
                    this.router.navigate("#/capture/thankyou?ext=1&url=#/");
                }else{
                    this.router.navigate('#/user/video/brand/' + this.video_id);
                }
            }
            // window.location.reload();
        } else if (this.captureType == 3) {
            this.router.navigate('#/user/video/email/' + this.video_id);
            window.location.reload();
        } else if (this.captureType == 5) {
            // let params = (new URL(document.location)).searchParams;
            // console.log("outlook params ==================>", params);
            let url = window.location.href;
            if (url.includes('_host_Info')) {
              let auth_token = (url.split('link_key=')[1] || '').split('&')[0];
              let loopLimit = 10;
              let interval = setInterval(()=>{
                this.videoMessageAPI.getOutlookDataById(this.video_id, auth_token,
                (data)=>{
                  console.log("success first ==========>", loopLimit, data);
                  if(data.status == 3 || loopLimit == 0){
                    var origin= window.location.origin
                    clearInterval(interval);
                    $.getScript("https://appsforoffice.microsoft.com/lib/1.1/hosted/office.js").then(function () {
                      Office.onReady(function () {
                          Office.context.ui.messageParent('video recorded or uploaded successfully', { targetOrigin: origin });
                      });
                  });
                  loopLimit--;
                }
              },(data)=>{
                console.log("success ==========>", data);
              })
              }, 3000);

            } else {
                if(this.authService.getUser().role=="WLADMIN" && this.user_id){
                    this.router.navigate('#/wladmin/user/'+this.user_id+'/video/message/' + this.video_id);
                }else{
                    this.router.navigate('#/user/video/message/' + this.video_id);
                } 
            
                window.location.reload();
            }

        } else if (this.captureType == 4) {
            if (done)
                this.router.navigate("#/capture/thankyou" +
                    (this.mlink_return_url ?
                        "?ext=1&url=" + this.mlink_return_url
                        : ""));
            else
                this.router.navigate('#/capture/case/' + this.capture_key);

        } else {



            this.router.navigate("#/capture/thankyou" +
                (this.captureType == 1 ?
                    (this.mlink_return_url ?
                        "?ext=1&url=" + this.mlink_return_url
                        : "?url=" + (this.testimonialForm ? "/" : +"link/" + this.capture_key))
                    : (this.mlink_return_url ?
                        "?ext=1&url=" + this.mlink_return_url
                        : "")
                )
            );
        }
    }

    cancel() {
        if (this.fileUploadScreen == true) {
            this.videoFile = null;
            this.showUploadVideoPreview = false;
            this.showSubmitButton = false;
        } else if (this.captureType == 5) {
            // this.router.navigate('#/user/video/message/' + this.video_id);
        }
        else {
            this.router.navigate('#/user/video/email/' + this.video_id);
        }
    }

    setData(org_name, mlink_return_url, chrome_min_ver, instructions, topic) {

        this.instructions = instructions;
        this.mlink_return_url = mlink_return_url;
        this.org_name = org_name;
        this.chrome_min_ver = chrome_min_ver;
        this.topic = instructions;

    }

    toggleCameraClicked() {
        this.recorder.toggleCamera();
    }

    recordClicked() {
        if (this.recording) {
            try {
                this.recorder.stop();
                // console.log("this....recordclicked stop",this);

            } catch (ex) {
                this.reportLogMessage(JSON.stringify(ex));
                this.reportError("Unexpected Error stopping recording");
                this.recordTime = null;
                throw ex;
            }
        }
        else {
            this.recordTimeClass = "";
            this.countDown = 5;
            this.recordTime = 5;
            console.log("this....recordclicked", this);
            setTimeout(this.countDownTimer.bind(this), 1000);

        }


    }

    countDownTimer() {
        this.countDown--;
        this.recordTime = this.countDown.toString();
        if (this.countDown > 0) {

            setTimeout(this.countDownTimer.bind(this), 1000);
        } else {
            try {
                this.recorder.record();
            } catch (ex) {
                this.reportLogMessage(JSON.stringify(ex));
                this.reportError("Unexpected Error starting recording");
                this.recordTime = null;
                throw ex;
            }
        }

    }

    playClicked() {

        if (this.playing) {

            try {
                this.recorder.stop();
            } catch (ex) {
                this.reportLogMessage(JSON.stringify(ex));
                this.reportError("Unexpected Error stopping playback");
                throw ex;
            }
        }
        else {
            try {
                this.recorder.play();
            } catch (ex) {
                this.reportLogMessage(JSON.stringify(ex));
                this.reportError("Unexpected Error starting playback");
                throw ex;
            }
        }
    }

    saveClicked() {
        //This method is clicked once we submit the recorded video
        this.showSubmitButton = false;
        this.saving = true;
        // var retrievedObject = localStorage.getItem('uploadFileProgress');
        if (this.fileUploadScreen == true) {
            this.showMessage = true;
            this.findProgress();
        }


        // this.composeEmailShow = true;
        try {
            //this.recorder => capture/fileUpload/fileUpload.js
            this.recorder.save(this.fileUploadScreen, this.video_id, this.brandedVideo);

        } catch (ex) {
            console.log("async await error", JSON.stringify(ex));
            this.reportLogMessage(JSON.stringify(ex));
            this.reportError("Unexpected Error saving video");
            this.saving = false;
            throw ex;
        }
        console.log("compose email button enabled");
        //  this.composeEmailEnable = true;
        this.reportLogMessage("Saving...");

        window.onbeforeunload = null;
        localStorage.removeItem('magni_v_device_id')
        localStorage.removeItem('magni_a_device_id')

    }

    findProgress() {
        if (localStorage.getItem("uploadFileProgress") != null) {
            this.progressFileUpload = localStorage.getItem('uploadFileProgress');
        }
        if (this.progressFileUpload < 100) {
            setTimeout(this.findProgress.bind(this), 250);

        }


    }

    composeEmail() {
        var retrievedObject = localStorage.getItem('VideoFileName');
        this.file_name = retrievedObject;
        localStorage.removeItem("VideoFileName");
        this.saveComplete(this.file_name);
    }

    recorderReady() {
        this.ready = true;
        this.reportLogMessage("Recorder ready");
        this.pending = false;
    }

    recordingStarted() {
        this.recording = true;
        this.pending = false;
        this.recordTime = "START!";
        this.reportLogMessage("Recording started");
        this.recordBtn.focus();
    }
    recordingComplete() {
        this.recording = false;
        this.recorded = true;
        this.pending = false;
        this.recordTime = null;
        this.reportLogMessage("Recording complete");

        window.onbeforeunload = function (event) { event.returnValue = 'Your testimonial has not yet been submitted.'; return event.returnValue; }
    }

    recorderPending() {
        this.pending = true;
    }

    playbackStarted() {
        this.playing = true;
        this.pending = false;
        this.reportLogMessage("Playback started");
    }

    playbackComplete() {
        this.playing = false;
        this.pending = false;
        this.reportLogMessage("Playback complete");
    }

    saveComplete(filename) {
        this.pending = false;
        this.reportLogMessage("Save complete");
        console.log("Save complete");
        var data = {
            capture_key: this.capture_key,
            file_name: filename,
            video_id: this.video_id,
            consent: this.consent
        }
        this.reportLogMessage("Finalizing capture");
        console.log("Finalizing capture");
        this.api.completeCapture(data, this.captureCompleteSuccess.bind(this), this.saveLoadError.bind(this));
    }

    reportTime(time) {
        if (this.maxRecordTime - Math.floor(time) == 5) {
            this.reportClosing();
            // this.recordTimeClass="";
            // this.countDown = 5;
            // this.recordTime = 5;
            // setTimeout(this.countDownTimer.bind(this), 1000);
        }
        else if (this.maxRecordTime - Math.floor(time) > 5) {
            this.recordTimeClass = "recordTimeBottom";
            this.recordTime = (this.maxRecordTime - Math.floor(time) - 5).toString() + "s remaining";
        }
    }

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    previewVideoFile() {
        var file_size = (this.videoFile[0].size / (1024 * 1024)).toFixed(2);
        console.log("file size", file_size);

        if (file_size < 200) {

            this.showSubmitButton = true;
            this.showUploadVideoPreview = true;
            this.blobURL = URL.createObjectURL(this.videoFile[0]);
            try {
                if (this.recorder == this.fileupload) {
                    this.recorder.uploadFile(this.videoFile);

                }
                else if (this.recorder == this.webrtc) {
                    this.recorder.uploadFile(this.videoFile[0]);
                }
                else {
                    this.recorder.uploadFile(this.videoFile[0]);
                }
            } catch (ex) {
                console.log("upload file error", JSON.stringify(ex));
                this.reportLogMessage(JSON.stringify(ex));
                this.reportError("Unexpected Error uploading video");
                this.saving = false;
                throw ex;
            }
            this.reportLogMessage("Uploading...");

            window.onbeforeunload = null;

        }
        else {
            this.videoFile = null;
            this.showUploadVideoPreview = false;
            this.showSubmitButton = false;

            alert("File size exceed, try again!")
        }

    }
    reportClosing() {
        this.recordTimeClass = "";
        this.videoStopTime = 10;
        this.recordTime = "0";
        console.log("this....reportClosing", this);
        setTimeout(this.countDownVideoCapture.bind(this), 1000);
        // if (this.maxRecordTime - Math.floor(time) == 5 || this.maxRecordTime - Math.floor(time) == 4 )
        // {
        //     this.recordTime = "0";
        // }
        // else if (this.maxRecordTime - Math.floor(time) < 4)
        // {
        //     this.recordTime = "STOP";
        // }
    }

    countDownVideoCapture() {
        this.videoStopTime--;
        if (this.videoStopTime % 2 == 0) {

            this.recordTime = "";


        }
        else if (this.videoStopTime > 6) {
            this.recordTime = "0";

        }
        else {
            this.recordTime = "STOP";

        }
        if (this.videoStopTime > 0) {
            setTimeout(this.countDownVideoCapture.bind(this), 500);
        }
        // else {
        //     try {
        //         this.recorder.record();
        //     } catch (ex) {
        //         this.reportLogMessage(JSON.stringify(ex));
        //         this.reportError("Unexpected Error starting recording");
        //         this.recordTime = null;
        //         throw ex;
        //     }
        // }

    }

    reportError(msg, permissionDenied = false) {
        this.reportLogMessage(msg);
        if (this.recorder && this.recorder.kill)
            this.recorder.kill();
        if (this.captureType == 3)
            this.router.navigate("#/capture/error?url=video/email/" + this.video_id + (permissionDenied ? "&permission_denied=1" : ""));
        else if (this.captureType == 5)
            this.router.navigate("#/capture/error?url=video/message/" + this.video_id + (permissionDenied ? "&permission_denied=1" : ""));
        else
            this.router.navigate("#/capture/error?url=" + (this.captureType == 1 ? "link/" : (this.captureType == 2 ? "brand/" : "")) + this.capture_key + (permissionDenied ? "&permission_denied=1" : ""));
    }

    reportLogMessage(msg) {
        try {
            var data = {
                capture_key: this.capture_key,
                capture_type: this.captureType,
                video_id: this.video_id,
                user_agent: navigator.userAgent,
                message: msg
            };
            // this.logApi.log(data);
        } catch (ex) {
            this._error.apply(console, [ex]);
        }
    }

    closeInstructions() {
        //this.userInstructions.style.display = "none";
        sessionStorage["magnfi_capture_inst_closed"] = true;
    }

    openInstructions() {
        this.userInstructions.style.display = "";
    }




    is_email(email) {
        var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailReg.test(email);
    }
}
